<script setup lang="ts">
import { ref, computed, onBeforeMount, onUnmounted } from 'vue';

import { useStation } from "@/store/station";
import { useUserStore } from "@/store/user";
import { useRoute, useRouter } from 'vue-router';
import { useErrorOverlay } from "@/store/overlays/error-overlay";
import { useLoadingOverlay } from "@/store/overlays/loading-overlay";
import offlineOverlay from "@/components/common/overlays/offline-overlay.vue";

import ChargeStatus from "./charge-status.vue";
import StationsMap from "./stations-map.vue";
import ConfirmationSheet from "./confirmation-sheet.vue";
import StartChargeBtn from "./start-charge-btn.vue";

const station = useStation();
const user = useUserStore();
const error_overlay = useErrorOverlay();
const loading_overlay = useLoadingOverlay();
const route = useRoute();
const router = useRouter();

const needs_confirmation = ref<boolean>(false);
const is_authorized = computed((): boolean => {
  if (!station.qrcode) {
    return false
  }
  const user_can_charge: boolean = user.authorized_on(station.qrcode || -1);
  console.log(`[charge]: authorized: ${user_can_charge}`);

  if (user_can_charge) { error_overlay.hide(); }
  else if (user.logged) {
    console.log("[charge]: showing error overlay");
    error_overlay.show("UNAUTHORIZED");
  }
  return user_can_charge;
});

function toggle_confirmation() {
  needs_confirmation.value = ! needs_confirmation.value;
  console.log("Display confirmation sheet: ", needs_confirmation.value);
}

onBeforeMount(async () => {
  const station = useStation();
  const loading_overlay = useLoadingOverlay();
  loading_overlay.show();
  const qrcode: number = (route.params as unknown as { stationId: number }).stationId;
  console.log(`[charge.before]: qrcode is ${qrcode}`);
  const logged = await station.do_fetch(qrcode, true);
  if (! logged) {
    router.push("/login");
  }
});
onUnmounted(() => loading_overlay.hide());
</script>

<template>
  <v-container class="pa-0" fill-height fluid>
    <offline-overlay />
    <charge-status />
    <stations-map />
    <confirmation-sheet
      v-if="needs_confirmation"
      @toggle="toggle_confirmation"
    />
    <v-container v-else class="startChargeBtn" fluid>
      <v-layout class="justify-center">
        <start-charge-btn
          :is-authorized-station="is_authorized"
          @toggle="toggle_confirmation"
        />
      </v-layout>
    </v-container>
  </v-container>
</template>

<style scoped lang="scss">
.startChargeBtn {
  position: absolute;
  bottom: 10%;
  height: auto;
}
</style>

<!-- vim: softtabstop=2:shiftwidth=2
-->
